<template>
  <DefaultDataDesc :data-type="dataType"/>
  <div class="site-data">
    <template v-if="showSiteData">
      <van-button @click="showSiteData=false">隐藏模块</van-button>
      <p v-for="(row, index) in siteDataRows" :key="index" style="text-align: left">
        <span class="bold">类型:</span>&nbsp;<span>{{row["类型"]}}</span>&nbsp;
        <span class="bold">今日:</span>&nbsp;<span>{{row["今日"]}}</span>&nbsp;&nbsp;
        <span class="bold">累计:</span>&nbsp;<span>{{row["累计"]}}</span>&nbsp;&nbsp;
      </p>
      <p style="font-weight: bold;text-align: left;">客户端状态:</p>
      <div v-for="(client, index) in collectClients" class="collect-wrap" :key="index" style="text-align: left;display: flex;">
        <template v-if="client.userName">
          <div class="client-name">{{client.userName.replace("data-", "") || 'null'}}</div>&nbsp;
          <div :class="`client-status ${client.clientActive ? 'online':'offline'}`">{{client.clientActive ? "采集中" : "已断开"}}</div>&nbsp;
          <div class="client-time">{{showTime(client.lastActiveTime, 10)}}</div>&nbsp;
          <div :class="`client-device ${client.serverCollectDevice ? 'online':'offline'}`">{{client.serverCollectDevice ? "是" : "否"}}</div>&nbsp;
        </template>
      </div>
      <p style="font-weight: bold;text-align: left;">抓取状态:</p>
      <div v-for="(platform, index) in platforms" class="collect-wrap" :key="index" style="text-align: left;display: flex;">
        <template v-if="platform.name">
          <div class="client-name">{{platform.name || 'null'}}</div>&nbsp;
          <div :class="`client-status ${platform.online ? 'online':'offline'}`">{{platform.online ? "采集中" : "已断开"}}</div>&nbsp;
          <div class="client-time">{{showTime(platform.lastSuccessTime, 10)}}</div>&nbsp;
        </template>
      </div>
    </template>
  </div>
</template>
<style lang="less">
@import "@/app.less";
.site-data{
  text-indent: 0.5rem;
}
.collect-wrap{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  flex-wrap: nowrap;
  flex-direction: row;
  padding: 0.2rem 1rem;
  .client-status{
    white-space: nowrap;
  }
  .client-name{
    color:#000;
    width: 8rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .client-time{
    padding: 0 0.5rem;
    color: #666;
    white-space: nowrap;
    width: 5rem;
  }
  .client-status,.client-device{
    &.offline{
      color: @color2;
    }
    &.online{
      color: @color11;
    }
  }
}
</style>
<script>
import store from "@/store"
import API from "@/api"
import {onMounted, ref, watch} from "vue";
import user from "../api/user";
import DefaultDataDesc from "@/views/data-desc/DefaultDataDesc.vue";
export default {
  name: 'DataDesc',
  computed: {
    user() {
      return user
    }
  },
    components: {
      DefaultDataDesc
    },
    setup(){
      const userStore = store.userStore();
      const dataType = userStore.getDataType();
      const deviceId = userStore.getDeviceId();
      const siteDataRows = ref([]);
      const platforms = ref([]);
      /**
       *
       * @type {Ref<Array<DataCollectClient>>}
       */
      const collectClients = ref([]);
      const user = userStore.user;
      const isAdminDevice = (deviceId) => deviceId.endsWith("20f50e52ff83e1fd");

      const isShowSiteData = () => isAdminDevice(deviceId);

      const showSiteData = ref(isShowSiteData());

      const doQuerySiteData = async () => {

        const res = await API.data.querySiteData(deviceId);
        if(res.success){
          siteDataRows.value = res.data.rows;
          platforms.value = res.data.platforms;
        }
      };

      const showTime = (time, len) => {
        return time.substr(len);
      }

      const doCollectClients = async () => {
        const res = await API.data.queryCollectClients(deviceId);
        if(res.success){

          for(let i = 0; i < res.data.length; i++){
            if(res.data[i].userName === 'norkts'){
              res.data[i].userName = 'data-backup';
            }
          }

          collectClients.value = res.data;
        }
      };



      onMounted(() => {
        if(isAdminDevice(deviceId)){
          doQuerySiteData();
          doCollectClients();
        }
        watch(user, (user) => {
          showSiteData.value = isShowSiteData();
        });
      });

      return {dataType, showSiteData, siteDataRows, platforms,collectClients,showTime};
    }
}
</script>
